import AWN from 'awesome-notifications';
import 'awesome-notifications/dist/style.css';

const fallbackLabels = {
    tip: 'Tip',
    info: 'Info',
    success: 'Success',
    warning: 'Attention',
    alert: 'Error',
    async: 'Loading',
    confirm: 'Confirmation required',
    confirmOk: 'OK',
    confirmCancel: 'Cancel',
};

const runtimeLabels = () => {
    if (typeof window === 'undefined') {
        return {};
    }

    return window.khThemeRuntime?.notificationLabels || {};
};

export const khNotificationLabels = (overrides = {}) => {
    return Object.assign({}, fallbackLabels, runtimeLabels(), overrides || {});
};

export const khAwnOptions = (options = {}) => {
    const {labels = {}, ...rest} = options || {};

    return Object.assign({}, rest, {
        labels: khNotificationLabels(labels),
    });
};

export const khToastOptions = (options = {}) => khAwnOptions(options);

export const createKhNotifier = (options = {}) => new AWN(khAwnOptions(options));

if (typeof window !== 'undefined') {
    window.AWN = AWN;
    window.KHNotifications = Object.assign({}, window.KHNotifications || {}, {
        labels: khNotificationLabels,
        options: khAwnOptions,
        toastOptions: khToastOptions,
        createNotifier: createKhNotifier,
    });
}

export default AWN;
